import { useEffect, useState } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';

/**
 * Visualizador de imagem(ns) em tela cheia.
 * Aceita `url` (uma imagem) ou `images` (array de urls) com navegação por setas/teclado.
 * Fecha com X, clique fora ou Esc.
 */
export default function Lightbox({ url, images, index = 0, onClose }) {
  const list = (images && images.length ? images : (url ? [url] : [])).filter(Boolean);
  const [i, setI] = useState(index);

  useEffect(() => { setI(index); }, [index, url, images?.length]);

  const has = list.length > 0;
  const multi = list.length > 1;

  useEffect(() => {
    if (!has) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
      else if (multi && e.key === 'ArrowLeft') setI((x) => (x - 1 + list.length) % list.length);
      else if (multi && e.key === 'ArrowRight') setI((x) => (x + 1) % list.length);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [has, multi, list.length, onClose]);

  if (!has) return null;

  const prev = (e) => { e.stopPropagation(); setI((x) => (x - 1 + list.length) % list.length); };
  const next = (e) => { e.stopPropagation(); setI((x) => (x + 1) % list.length); };

  return (
    <div className="lightbox" onClick={onClose}>
      <button className="lightbox-x" onClick={onClose} aria-label="Fechar"><X size={20} /></button>

      {multi && <button className="lightbox-nav prev" onClick={prev} aria-label="Anterior"><ChevronLeft size={26} /></button>}
      <img src={list[i]} alt="Imagem ampliada" onClick={(e) => e.stopPropagation()} />
      {multi && <button className="lightbox-nav next" onClick={next} aria-label="Próxima"><ChevronRight size={26} /></button>}

      {multi && <span className="lightbox-counter">{i + 1} / {list.length}</span>}
    </div>
  );
}
